export enum MAIL_STATUS {
    EXISTS = "Exists",
    NOT_EXISTS = "NotExists",
    LOADING = "Loading",
    ERROR = "Error"
}
export enum FILE_LOADING_INFO {
    EXISTS = "Exists",
    NOT_EXISTS = "NotExists",
    LOADING = "Loading",
    ERROR = "Error"
}
export interface IMailInfo {
    accessToken: string;
    itemId: string;
    docRecno?: string | null;
    targetInbox?: string | null;
    isUnregistered?: boolean;
}

export interface IMultipleMailInfo {
    accessToken: string;
    itemIds: string[];
    targetInbox?: string | null;
}

export interface IMultipleEmailArchiveResult {
    ItemId: string;
    Recno: string | null;
    IsSuccess: boolean;
    ErrorMessage: string | null;
    Subject: string;
}

export type IMultipleMailSaveResponse = IMultipleEmailArchiveResult[];

export interface IDocumentDetails {
    AccessCodeDesc: string;
    CaseDescription: string;
    ArchiveCode: string;
    CaseNumber: string;
    CategoryCode: string;
    DocumentCategory?: string;
    DocumentDetailsLink: string;
    DocumentTitle: string;
    DocumentNumber: string;
    DocumentRecno?: number;
    OrgUnitName: string;
    Paragraph: string;
    ResponsibleName: string;
    Documentnumber?: string;
    FileStatus?: number;
    IsInImportArchive?: boolean;
    InsertMessage?: string;
    ImportArchiveLink?: string;
}
export interface IConfigInfo {
    VersionOf360ForHelp: string;
}

export enum FILE_STATUS {
    NORMAL = 0,
    CHECKED_OUT = 2,
    LOCKED = 9,
    DELETED = 99
}